module.exports = __webpack_public_path__ + "img/Consultation.9aaabd99.svg";